import React from "react";

import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

import ServiceIcon from "Components/ServiceIcon";
import * as Code from "ds/Code";
import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import { useCurrentService } from "Reducers/environment/hooks/useCurrentService";
import { AppRelationshipsTransformedType } from "Reducers/environment/service";
import { gitProjectSelector } from "Reducers/project/project";

import * as S from "./Relationships.styles";

export interface RelationshipProps {
  relationship: AppRelationshipsTransformedType;
}

const Relationship = ({ relationship }: RelationshipProps) => {
  const intl = useIntl();
  const currentService = useCurrentService();
  const { projectId, organizationId, environmentId } = useDecodedParams<{
    projectId: string;
    organizationId: string;
    environmentId: string;
  }>();

  const project = useSelectorWithUrlParams(gitProjectSelector);
  const environment = useSelectorWithUrlParams(environmentSelector);
  const commandPrefix = intl.formatMessage({ id: "CLI_command_name" });

  const cmd = `${commandPrefix} tunnel:single -p ${projectId} -e ${environment?.name} -A ${currentService?.name} -r ${relationship.name}`;
  const relationUrl = `/${organizationId}/${projectId}/${encodeURIComponent(environmentId)}/services/${relationship.service}`;
  const displayCodeBlock =
    project?.region && environment?.machine_name && relationship.name && cmd;

  const onClickRelationship = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <S.Cell>
        <Link to={relationUrl} onClick={onClickRelationship}>
          <S.Title>
            <S.RowLeftLayout>
              <ServiceIcon
                service={relationship.serviceObject}
                alt={`${relationship.name}-icon`}
              />

              {relationship.service}
            </S.RowLeftLayout>
          </S.Title>
        </Link>
      </S.Cell>
      <S.Cell>{relationship.endpoint}</S.Cell>
      {displayCodeBlock ? (
        <Code.Block isCopyable singleLine id={cmd}>
          {cmd}
        </Code.Block>
      ) : (
        <div />
      )}
    </>
  );
};

export default Relationship;
